"use client";

import React, { useEffect, useRef } from "react";

export default function CursorGlow() {
  const rafRef = useRef<number | null>(null);
  const posRef = useRef<{ x: number; y: number }>({ x: -100, y: -100 });

  useEffect(() => {
    const root = document.documentElement;

    const onMove = (e: MouseEvent) => {
      // Use pageX/pageY to account for scroll position
      posRef.current.x = e.pageX;
      posRef.current.y = e.pageY;
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(() => {
        root.style.setProperty("--cursor-x", `${posRef.current.x}px`);
        root.style.setProperty("--cursor-y", `${posRef.current.y}px`);
      });
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return <div aria-hidden="true" className="cursor-glow" />;
}
